import React from "react";
import { useTranslation } from "react-i18next";
import SFButton from "../../button";
import { SFAddIcon } from "../../icons";

const AddFilter = (props) => {
  const { t } = useTranslation();
  return (
    <SFButton
      variant="secondary"
      onClick={props.handleOnClick}
    >
      <SFAddIcon size="xsmall" />
      {t("components.queryBuilder.filterLabel")}
    </SFButton>
  );
};

export default AddFilter;
